import React, { StrictMode } from "react";
import { render } from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "./custom.scss";
import keycloak from "services/keycloak";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";
import * as serviceWorker from "./serviceWorker";

render(
  <StrictMode>
    <Provider store={store}>
      <ReactKeycloakProvider authClient={keycloak}>
        <Router>
          <App />
        </Router>
      </ReactKeycloakProvider>
    </Provider>
  </StrictMode>,
  document.getElementById("root")
);

serviceWorker.unregister();
